export interface WorkingOrderErrorMessage {
  title: string;
  body: string[];
}
